import React, { useCallback, useState } from 'react'
import { FinancingCallbackError } from './components/FinancingCallbackError'
import { FinancingCallbackForm } from './components/FinancingCallbackForm'
import { FinancingCallbackSuccess } from './components/FinancingCallbackSuccess'
import { EFinancingCallbackModalState } from './constants'
import type { IFinancingCallbackModalProps } from './types'

export const FinancingCallbackModal = (props: IFinancingCallbackModalProps) => {
  const { options } = props

  const [actionState, setActionState] = useState<EFinancingCallbackModalState>(EFinancingCallbackModalState.FORM)

  const setActiveSuccessState = useCallback(() => setActionState(EFinancingCallbackModalState.SUCCESS), [])
  const setActiveErrorState = useCallback(() => setActionState(EFinancingCallbackModalState.ERROR), [])

  switch (actionState) {
    case EFinancingCallbackModalState.SUCCESS:
      return <FinancingCallbackSuccess />
    case EFinancingCallbackModalState.ERROR:
      return <FinancingCallbackError />
    default:
    case EFinancingCallbackModalState.FORM:
      return (
        <FinancingCallbackForm
          onSuccessCallbackRequest={setActiveSuccessState}
          onErrorCallbackRequest={setActiveErrorState}
          context={options.context}
        />
      )
  }
}
